import {
  Flex,
  Link,
  Typography,
  emailRegex,
  telRegex,
} from '@iheartjane/reefer';
import { Form } from '@iheartjane/reefer-hook-form';

import { ContinueWith } from '@jane/shared-ecomm/components';

interface CreateAccountProps {
  errors: string[] | null;
  onAppleClick(): void;
  onGoogleClick(): void;
  onSubmit(newUser: CreateAccountFormData): void;
}

type CreateAccountFormData = {
  email: string;
  password: string;
  phone: string;
};

export const CreateAccountScreen = ({
  errors,
  onAppleClick,
  onGoogleClick,
  onSubmit,
}: CreateAccountProps) => {
  return (
    <Form name="create-account" onSubmit={onSubmit} width="100%">
      <Flex flexDirection="column" p={24} alignItems="center">
        <ContinueWith
          buttonSize="small"
          onAppleClick={onAppleClick}
          onGoogleClick={onGoogleClick}
          showAppleLogin
          showGoogleLogin
        />
        <Form.TextField
          type="email"
          autocomplete="off"
          label={
            <Typography variant="body-semibold" mt={16} mb={-8}>
              Email address
            </Typography>
          }
          name="email"
          required
          errorMessage="Please enter a valid email address."
          errorOnBlur
          pattern={emailRegex}
          disableMobileInputStyling
          mb={16}
          borderRadius="xs"
        />
        <Form.NumberField
          autocomplete="off"
          label={
            <Typography variant="body-semibold" mb={-8}>
              Phone number
            </Typography>
          }
          name="phone"
          required
          errorMessage="Phone is an invalid number"
          errorOnBlur
          pattern={telRegex}
          maskFormat="(###) ###-####"
          disableMobileInputStyling
          allowLeadingZeros
          helperText="Used only for reservation notices"
          mb={16}
          width="100%"
          borderRadius="xs"
        />
        <Form.TextField
          type="password"
          autocomplete="off"
          label={
            <Typography variant="body-semibold" mb={-8}>
              Password
            </Typography>
          }
          name="password"
          required
          pattern={/.*/}
          disableMobileInputStyling
          mb={24}
          borderRadius="xs"
        />

        {errors && (
          <Flex flexDirection="column" justifyContent="center" mt={-12}>
            {Array.isArray(errors) ? (
              errors.map((error, index) => (
                <Typography
                  color="error"
                  mb={12}
                  mx="auto"
                  key={`error-${index}`}
                  textAlign="center"
                >
                  {error}
                </Typography>
              ))
            ) : (
              <Typography color="error" mb={12} mx="auto">
                There was an error creating your account.
              </Typography>
            )}
          </Flex>
        )}

        <Form.SubmitButton
          full
          size="small"
          variant="primary"
          label="Sign up"
          mb={24}
          data-testid="login-submit-btn"
        />
        <Typography textAlign="center" color="grays-mid">
          By continuing, I agree to{' '}
          <Link href="https://www.iheartjane.com/terms" color="grays-mid">
            Jane's Terms of Service
          </Link>{' '}
          and{' '}
          <Link
            href="https://www.iheartjane.com/privacy-policy"
            color="grays-mid"
          >
            Privacy Policy
          </Link>
          .
        </Typography>
      </Flex>
    </Form>
  );
};
